import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import breakpoints from "../../../styles/breakpoints";
import { fonts } from "../../../styles/variables";
import { Input } from "../Input";
import searchImg from "../../../assets/images/icons/search.svg";
import { I18N_NAMESPACES } from "../../../helpers/constants";

const SearchContainer = styled.div`
  ${(props) =>
    props.isFromGuidesSearchPage
      ? css`
          width: 100%;
          padding-right: 30px;
        `
      : css`
          padding-top: 20px;
          padding-left: 30px;
        `}

  ${breakpoints.smDown} {
    display: block;
    position: fixed;
    left: 0;
    width: 100vw;
    bottom: 0;
    z-index: 1000;
  }
`;

const SearchTitle = styled.h3`
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  font-size: 25px;
  margin-bottom: 15px !important;
  line-height: 0.9;
  ${breakpoints.smDown} {
    display: none;
  }
`;

const SearchInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  ${breakpoints.smDown} {
    position: fixed;
    bottom: -1px;
    left: -1px;
    background-color: white;
    width: calc(100% + 2px); // Avoids blank gaps around the input
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 0 0;
    border: none;
  }
  padding-right: 10px;
`;

const SearchIcon = styled.img`
  min-width: 15px;
  height: 15px;
  cursor: pointer;
`;

const SearchInput = styled(Input)`
  width: 100%;
  float: right;
  flex: 1;
  border: none;
`;

const GuidesSearchField = (props) => {
  const { onChange, onKeyPress, value, isFromGuidesSearchPage } = props;

  const { t } = useTranslation(I18N_NAMESPACES.COMMON);

  return (
    <SearchContainer isFromGuidesSearchPage={isFromGuidesSearchPage}>
      <SearchTitle>{t("common:search")}</SearchTitle>
      <SearchInputContainer>
        <SearchInput
          placeholder={t("common:searchArticles")}
          onChange={(event) => onChange(event.target.value)}
          onKeyPress={(event) => onKeyPress(event)}
          value={value}
        />
        <SearchIcon src={searchImg} onClick={() => onKeyPress({ key: "Enter" })} />
      </SearchInputContainer>
    </SearchContainer>
  );
};

GuidesSearchField.propTypes = {
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  value: PropTypes.string.isRequired,
  isFromGuidesSearchPage: PropTypes.bool,
  location: PropTypes.shape({}),
};

GuidesSearchField.defaultProps = {
  onKeyPress: () => {},
  isFromGuidesSearchPage: false,
  location: {},
};

export default GuidesSearchField;
